// removed by extract-text-webpack-plugin
module.exports = {"formLabel":"formLabel___1Dejf"};


//////////////////
// WEBPACK FOOTER
// ./src/components/HookFormInputs/FormError.module.less
// module id = 2852
// module chunks = 29